jQuery(document).ready(function ($) {
  var $lines = $(".box-carousel-lines .swiper");

  if (!$lines.length) return;

  $lines.each(function (index, element) {
    new Swiper(element, {
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 10,
      speed: 600,
      rewind: true,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: $(element).parent().find(".carousel-nav.next")[0],
        prevEl: $(element).parent().find(".carousel-nav.prev")[0],
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 30,
        },
      },
    });
  });
});
